import { Injectable } from '@angular/core';
import { CategoriasWebMenu } from '../ecommerce-generico/interfaces/categorias-webmenu.interface';
import { MarcasEcommerce } from '../ecommerce-generico/interfaces/marcas-ecommerce.interface';

@Injectable({
  providedIn: 'root'
})
export class CategoriesBrandsService {

  private categoriasWeb: CategoriasWebMenu[] = [];
  private marcasDestacadas: MarcasEcommerce[] = [];

  ordenCategorias = (a: CategoriasWebMenu, b: CategoriasWebMenu): number => {
    if (a.orden > b.orden) {
      return 1;
    }
    if (a.orden < b.orden) {
      return -1;
    }
    return 0;
  }

  /**
   * Reemplaza el listado plano de categorías y arma el árbol de hasta 3 niveles (padre/sub/tier3).
   */
  reemplazarCategorias(categoriasCrudas: CategoriasWebMenu[]) {
    this.categoriasWeb = categoriasCrudas;
    this.ordenarCategorias();
  }

  reemplazarMarcas(marcas: MarcasEcommerce[]) {
    this.marcasDestacadas = marcas;
  }

  private ordenarCategorias() {
    let categorias: CategoriasWebMenu[] = [];
    this.categoriasWeb.forEach(
      (categoria: CategoriasWebMenu) => {
        if (categoria.padre == 0) {
          this.categoriasWeb.forEach(subcategoria => {
            if (categoria.categoria == subcategoria.padre) {
              this.categoriasWeb.forEach(tiercategoriatres => {
                if (subcategoria.categoria == tiercategoriatres.padre) {
                  subcategoria.subCategorias.push(tiercategoriatres);
                }
              })
              categoria.subCategorias.push(subcategoria);
            }
          })
          categorias.push(categoria);
        }
      }
    );
    this.categoriasWeb = categorias;
  }

  getCategoriasWeb() {
    let categorias: CategoriasWebMenu[] = [];
    this.categoriasWeb.forEach(k => {
      if (k.subCategorias.length != 0) {
        k.subCategorias.sort(this.ordenCategorias)
      }
      categorias.push(k);
    })
    categorias.sort(this.ordenCategorias);
    return categorias;
  }

  getMarcasDestacadas() {
    let marcas: MarcasEcommerce[] = [];
    this.marcasDestacadas.forEach(k => {
      if (k.destacada == "S") {
        marcas.push(k);
      }
    })
    return marcas;
  }
}
